<template>
  <div class="flex act-container">
    <div v-if="!queryTypeDisabled">
      <act-preview
          navigationBg="#F72727"
          phoneHeaderFixedColor="#fff"
          navigationTitle="助力劵">
        <div class="slot">
          <div class="preview-goods-list prev-upload">
            <div
                class="upload-img"
                v-if="rule.length && rule[0].couponSendId"
                @click="batchSetting"
            >
              <span
                  class="hmicon icon-hao pointer"
              ></span>
            </div>
            <div class="empty" v-if="rule.length && !rule[0].couponSendId">
              还没有优惠券立即
              <el-button type="primary" size="mini" @click="batchSetting"
              >添加优惠券
              </el-button
              >
            </div>
            <template v-if="rule.length && rule[0].couponSendId">

              <div class="coupon-item"  v-for="(v, i) in rule" :key="i">
                <div class="delete-item" @click="deleteChild(i)">
                  <span class="hmicon  hmicon icon-shanchu1 pointer"></span>
                </div>

                <div class="goods-head flex">
                  <div class="head-ms flex flex-column flex-between ">
                    <div class="ms">{{v.name}}</div>
                    <div class="flex flex-wrap flex-1">
                      <div class="rule-bq text-center">需{{ v.needHelpSum }}人助力</div>
                      <div class="rule-bq text-center">最多可参与{{ v.eachLaunchUpperLimit }}次</div>
                    </div>
                  </div>
                  <div class="head-btn item-center text-center">
                    <div class="mb10"><span style="font-size: 24px;">{{ v.ruleNum }}</span>张</div>
                    <div class="btn-wrapper">立即拼券</div>
                  </div>
                </div>
                <!--<div class="goods-item flex">
                  <div class="rule-wrapper flex flex-center item-center">
                    <div class="flex flex-column flex-center">
                      <div>￥<span class="rule-money">{{ v.ruleMoney }}</span></div>
                      <div class="text-center">满{{v.doRuleMoney}}使用</div>
                    </div>
                  </div>
                  <div style="width: 50%"></div>
                  <div style="width: 20%"></div>



                  &lt;!&ndash;<div class="img-wrapper">
                    <img :src="v.wxshopskupic" alt=""/>
                  </div>
                  <div class="flex-1 flex flex-column flex-between info-wrapper">
                    <div>
                      <div class="goods-name text-overflow-2">
                        {{ v.wxshopSpuName }}
                      </div>
                    </div>
                    <div
                        class="exchange-promition-wrapper"
                        v-if="v.specIdGroupName"
                    >
                      <span class="exchange-promition">
                        {{ v.specIdGroupName }}
                      </span>
                    </div>
                    <div class="flex item-center progress-wrapper">
                      <div
                          class="progress flex flex-between btn light"
                          :style="{
                          background: storeStyle.lightColor
                        }"
                      >
                        <div class="primary btn slide"></div>
                      </div>
                      <div class="primary percent">0%</div>
                    </div>
                    <div class="flex">
                      <div class="flex-1 flex item-end">
                        <div class="" v-if="v.lowerLimitPrice">
                          可砍至<span :style="{ color: storeStyle.baseColor }"
                        >￥
                            <strong>{{ v.lowerLimitPrice }}</strong>
                          </span>
                        </div>
                        <div v-if="v.retailPrice" class="origin-price">
                          ￥{{ v.retailPrice }}
                        </div>
                      </div>
                      <div>
                        <div
                            class="btn round"
                            :style="{ background: storeStyle.baseColor }"
                        >
                          去砍价
                        </div>
                      </div>
                    </div>
                  </div>&ndash;&gt;
                </div>-->
              </div>


            </template>
          </div>
        </div>
      </act-preview>
    </div>
    <div class="add-goods-containers" style="width: 100vw">
      <div class="act-step-wrapper">
        <hm-step
            :steps="steps"
            :scroll="true"
            :step="currentStep"
            @scroll="windowScroll"
        ></hm-step>
      </div>
      <div class="act-wrapper">
        <el-scrollbar :style="{ height: scrollHeight + 'px' }">
          <div class="pvw flex flex-wrap">
            <div class="flex-4">
              <el-form
                  :model="ruleForm"
                  :rules="rules"
                  ref="ruleForm"
                  label-width="170px"
              >
                <div id="base">1.基本信息</div>
                <el-form-item label="活动标题" prop="gameName">
                  <el-input
                      maxlength="25"
                      style="width: 400px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="ruleForm.gameName"
                      placeholder="请输入活动标题"
                  ></el-input>
                </el-form-item>
                <el-form-item label="活动时间段选择" prop="activityDate">
                  <el-date-picker
                      :disabled="type === 'details'"
                      :default-time="['00:00:00', '23:59:59']"
                      v-model="ruleForm.activityDate"
                      :picker-options="pickerOptions"
                      type="datetimerange"
                      align="right"
                      start-placeholder="活动开始时间"
                      end-placeholder="活动结束时间"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      size="small"
                      class="mr10"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="活动分享文案" prop="gameShareContent">
                  <el-input
                      :maxlength="30"
                      style="width: 400px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="ruleForm.gameShareContent"
                      placeholder="请输入活动分享文案，30字以内"
                  ></el-input>
                </el-form-item>
                <el-form-item label="背景音乐链接" prop="gameBgm">
                  <el-input
                      style="width: 400px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model="ruleForm.gameBgm"
                      placeholder="请输入音乐链接/音乐网络地址"
                  ></el-input>
                </el-form-item>

                <el-form-item label="活动规则说明" prop="gameRuleRemark">
                  <hm-rich-editor
                      v-model="ruleForm.gameRuleRemark"
                      :html="ruleForm.gameRuleRemark"
                  />
                </el-form-item>

                <div class="mt40" id="gameRule">
                  {{ steps.length === 3 ? 2 : 2 }}活动规则
                </div>

                <el-form-item class="mt20" label="单人最多可发起次数" prop="eachLaunchUpperLimit">
                  <el-input
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="ruleForm.eachLaunchUpperLimit"
                  ></el-input>
                  次
                  <div class="font-ms">对于该活动里面的优惠券，最多可以发起的次数，每张劵发起次数不能超过优惠券设置的单人可发起助力次数</div>
                </el-form-item>
                <el-form-item label="助力上限模式" prop="subStockType">
                  <el-radio-group v-model="ruleForm.subStockType" :disabled="queryTypeDisabled">
                    <el-radio label="launch">发起助力后后扣减</el-radio>
                    <el-radio label="success">助力成功后扣减</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="单人最多帮忙次数限制" prop="helpUpperLimitMode">
                  <el-radio-group v-model="ruleForm.helpUpperLimitMode" :disabled="queryTypeDisabled">
                    <el-radio label="daily">每日更新</el-radio>
                    <el-radio label="active">活动时间内</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="单人最多可帮忙助力次数" prop="eachHelpUpperLimit">
                  <el-input
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="ruleForm.eachHelpUpperLimit"
                  ></el-input>
                  次
                  <div class="font-ms">对于该活动里面的优惠券，单人最多可以帮忙助力其他人活动的次数(不包含给自己助力) /每天</div>
                </el-form-item>

                <el-form-item label="自动成团" prop="automateBeTeam">
                  <el-switch
                      v-model="ruleForm.automateBeTeam"
                      active-text="开启"
                      inactive-text="关闭"
                      :disabled="queryTypeDisabled"
                      active-value="yes"
                      inactive-value="no">
                  </el-switch>
                  <div class="font-ms">开启后，未达到助力人数时，系统会自动判断助力成功</div>
                </el-form-item>

                <el-form-item label="发起助力时间" prop="launchTimeType">
                  <el-radio-group :disabled="queryTypeDisabled" v-model="ruleForm.launchTimeType">
                    <el-radio :label="'gameEnd'">直至活动结束</el-radio>
                    <el-radio :label="'custom'">自定义时长</el-radio>
                  </el-radio-group>
                  <span class="font-ms">（当时长超过了活动结束时间，以活动结束时间为准)</span>
                  <div v-if="ruleForm.launchTimeType == 'custom'">
                    <el-input
                        size="small"
                        style="width: 160px;"
                        clearable
                        :disabled="queryTypeDisabled"
                        class="mr10 ipt"
                        v-model.trim="ruleForm.customTimeNum"
                    ></el-input>
                    分钟
                    <span style="color: #FF7F10">（使用期限必须为大于或等于0的整数）</span>
                  </div>
                </el-form-item>

                <el-form-item label="添加优惠券" prop="drawTypeList">
                  <div v-if="!queryTypeDisabled" class="flex batch flex-between item-center">
                    <div>
                      <el-button size="small" type="primary" @click="batchSetting"
                      >添加优惠券
                      </el-button
                      >
                    </div>
                  </div>
                  <el-table
                      :data="rule"
                      row-key="wxshopSkuId"
                      border
                      class="mt10"
                      stripe
                      max-height="400"
                      style="width: 100%"
                      :header-cell-style="{
                      background: '#f7f7f7',
                      color: '#606266'
                    }"
                  >
                    <el-table-column
                        type="index"
                        label="序号"
                        width="50"
                    ></el-table-column>
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="name"
                        label="优惠券发放名称"
                    >
                    </el-table-column>
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="totalStockSum"
                        label="活动库存"
                    >
                      <template slot="header">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="活动库存不能超过优惠券包发放数量"
                            placement="top"
                        >
                          <div class="text-center primary">活动库存</div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <el-input
                                disabled
                            style="width:100px"
                            v-model.trim="scope.row.totalStockSum"
                            size="small"
                            @mousewheel.prevent.native
                            @input="
                            filterGt0OrFixed(
                              'totalStockSum',
                              scope.$index
                            )
                          "
                            clearable
                            placeholder="活动库存"
                        ></el-input>
                        <!--span v-else>{{ scope.row.totalStockSum }}</span -->
                      </template>
                    </el-table-column>
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="eachLaunchUpperLimit"
                        label="单人可发起助力次数"
                    >
                      <template slot-scope="scope">
                        <el-input
                            clearable
                            style="width:100px"
                            v-if="!queryTypeDisabled"
                            @mousewheel.prevent.native
                            @input="
                            filterGt0OrFixed('eachLaunchUpperLimit', scope.$index)
                          "
                            v-model.trim="scope.row.eachLaunchUpperLimit"
                            size="small"
                            placeholder="助力次数"
                        ></el-input>
                        <span v-else>{{ scope.row.eachLaunchUpperLimit }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="needHelpSum"
                        label="需要助力人数"
                    >
                      <template slot-scope="scope">
                        <el-input
                            clearable
                            type="number"
                            style="width:100px"
                            @mousewheel.prevent.native
                            v-if="!queryTypeDisabled"
                            @input="
                            filterGt0OrFixed(
                              'needHelpSum',
                              scope.$index
                            )
                          "
                            v-model.trim="scope.row.needHelpSum"
                            size="small"
                            placeholder="助力人数"
                        ></el-input
                        >
                        <span v-else>{{ scope.row.needHelpSum }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                        header-align="center"
                        align="center"
                        label="操作"
                        width="80px"
                        v-if="!queryTypeDisabled"
                    >
                      <template slot-scope="scope">
                        <div class="flex flex-center">
                          <div
                              v-if="scope.$index === 0"
                              class="add-wrapper flex flex-center"
                              style="marginLeft:0"
                          >
                            <span
                                class="hmicon icon-hao pointer"
                                @click="addChild(scope.$index)"
                            ></span>
                          </div>
                          <div
                              class="minus-wrapper flex flex-center"
                              style="marginLeft:0"
                              v-else
                          >
                            <span
                                class="hmicon icon-jianhao pointer"
                                @click="deleteChild(scope.$index)"
                            ></span>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
                <div class="flex flex-center">
                  <el-button
                      type="primary"
                      size="small"
                      @click="submitForm('ruleForm')"
                  >发布
                  </el-button
                  >
                  <el-button size="small" @click="$router.back(-1)"
                  >返回
                  </el-button
                  >
                </div>
              </el-form>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误
        </div>
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column
              prop="goodsSn"
              header-align="center"
              align="center"
              label="无效货号"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="specBarcode"
              label="无效条码"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" width="900px" title="选择优惠券">
      <div>
        <div class="flex flex-start">

        </div>
        <el-table
            class="mt20"
            :data="couponList"
            border
            @selection-change="getSelectedCoupons"
            max-height="400"
        >
          <el-table-column
              header-align="center"
              align="center"
              type="selection"
              width="55px"></el-table-column>
          <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
              width="80px"
              :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
              prop="name"
              header-align="center"
              align="center"
              label="优惠券发放名称"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="send_num"
              label="发放数量"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="ruleNum"
              label="包含优惠券数量"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination mb20">
          <el-pagination
              background
              :total="total"
              @current-change="paging"
              @size-change="handleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPage"
          ></el-pagination>
        </div>
        <div class="btn-wrapper mb20 flex flex-center">
          <el-button size="small" type="primary" @click="saveCoupons"
          >确 定</el-button
          >
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HmStep from "@/components/HmStep";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import {arrayUnique2} from "@/utils/utils";
import actPreview from "@/components/actPreview";
import {mapGetters} from "vuex";

import XLSX from "xlsx";

let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    HmStep,
    myUpload,
    HmRichEditor,
    actPreview
  },
  data() {
    const patterndLaunchTimeTypeFunc = function (rule, val, callback) {
      let flag = true;
      if (this.ruleForm.launchTimeType == "custom") {
        if (!this.ruleForm.customTimeNum) {
          flag = false;
        }
      }
      if (flag) {
        callback();
      } else {
        return callback(new Error("请输入自定义时长时间"));
      }
    }.bind(this);
    const patterndDrawTypeListFunc = function (rule, val, callback) {
      let flag = true;
      this.rule.forEach(v => {
        if (!v.totalStockSum || !v.eachLaunchUpperLimit || !v.needHelpSum) {
          flag = false;
        }
        if (v.totalStockSum && v.send_num && v.totalStockSum > v.send_num) {
          return callback(new Error(v.name + "的活动库存不能超过发放库存数" + v.send_num));
        }
        if (v.needHelpSum && v.needHelpSum < 2) {
          return callback(new Error("需要助力最小人数必须大于1"));
        }
      });
      if (flag) {
        callback();
      } else {
        return callback(new Error("请填写所有项"));
      }
    }.bind(this);
    const patterndCouponListFunc = function (rule, val, callback) {
      let flag = true;
      this.rule.forEach(v => {
        if (!v.couponSendId) {
          flag = false;
        }
      });
      if (flag) {
        callback();
      } else {
        return callback(new Error("请选择购物券发放规则"));
      }
    }.bind(this);
    const actDate = function (rule, val, callback) {
      // if (val > +this.ruleForm.actMemberUpperLimit) {
      //   return callback(new Error("已报名人数不能大于活动人数上限"));
      // }
      if (!this.ruleForm.activityDate.length > 0) {
        return callback(new Error("请选择活动时间段"));
      }

      callback();
    }.bind(this);
    const patterndMainImgUrlFunc = function (rule, val, callback) {
      if (!this.listHeaderImgUrl) {
        return callback(new Error("请选择主图"));
      }
      callback();
    }.bind(this);
    return {
      type: this.$route.query.type,
      selectOther: false,
      selectAll: false,
      expressList: [],
      errValidGoods: false,
      errInputResult: [],
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
              time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      },
      endTime: "2019-11-11 18:12:00",
      isRadio: false,
      listHeaderImgUrl: "",
      storeId: "",
      currentStep: 1,
      scrollHeight: 0,
      show: false,
      dialogVisible: false,
      steps: [
        {
          id: "base",
          name: "基本信息"
        },
        {
          id: "gameRule",
          name: "活动规则"
        }
      ],
      ruleForm: {
        gameName: "",
        gameRuleRemark: "",
        gameShareContent: "",
        gameBgm: "",
        eachLaunchUpperLimit: "",
        eachHelpUpperLimit: "",
        automateBeTeam: "no",
        launchTimeType: "gameEnd",
        customTimeNum: ""
      },
      screening: "",
      bargainType: "people",
      rule: [
        {
          name: "",
          needHelpSum: "",
          eachLaunchUpperLimit: "",
          ruleNum: ""
        }
      ],
      threshold: {
        expressModeGroup: []
      },
      rules: {
        visualJoinNum: [
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            message: "请输入虚拟参与人数",
            trigger: "blur"
          }
        ],
        gameName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur"
          },
          {min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "blur"}
        ],
        gameShareContent: [
          {
            required: true,
            message: "请输入活动分享文案",
            trigger: "blur"
          }
        ],
        mainImgUrl: [
          {
            required: true,
            validator: patterndMainImgUrlFunc,
            trigger: "blur"
          }
        ],
        gameRuleRemark: [
          {
            required: true,
            message: "请输入活动规则说明",
            trigger: "blur"
          }
        ],
        activityDate: {
          required: true,
          validator: actDate,
          trigger: "blur"
        },
        drawTypeList: [
          {
            required: true,
            validator: patterndDrawTypeListFunc,
            trigger: "blur"
          },
          {
            required: true,
            validator: patterndCouponListFunc,
            trigger: "blur"
          }
        ],
        subStockType: [
          {
            required: true,
            message: "请选择扣减库存限制",
            trigger: "blur"
          }
        ],
        launchTimeType: [
          {
            required: true,
            validator: patterndLaunchTimeTypeFunc,
            trigger: "blur"
          }
        ]
      },

      options: [
        {
          value: "1",
          label: "1"
        }
      ],
      actDesc: {},
      sole: Boolean,
      isCollapse: true,
      total: 0,
      couponList: [],
      currentPage: 1,
      pageSize: 10,
      selectedCoupons: [],
      queryTypeDisabled: false
    };
  },
  computed: mapGetters(["storeStyle", "microShopStoreList"]),
  watch: {},
  created() {
    /*this.$store.dispatch("queryMicroStoreList");
    this.queryExpressList();*/
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, true);
    this.calcHeight();
    if (this.$route.query.gameId) {
      this.activityDetail().then(res => {
        this.ruleForm = res.result;

        this.ruleForm.activityDate = [
          res.result.gameStartTime,
          res.result.gameEndTime
        ];

        this.listHeaderImgUrl = res.result.gameBgp;

        this.rule = res.result.couponRuleModelList;
      });
    }
    if (this.$route.query.type == "details") {
      this.queryTypeDisabled = true;
    }
    this.$store.dispatch("queryStoreStyle");
  },
  destroyed: function () {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    //优惠券选择
    getSelectedCoupons(val) {
      this.selectedCoupons = val;
    },
    // 运费模板
    async queryExpressList() {
      const {result} = await this.$store.dispatch("storeExpressConfigList");
      this.expressList = [];
      if (result.defaultTemplate) {
        this.expressList.push(result.defaultTemplate);
      }
      this.expressList.push(...result.templateList);
    },
    getCheckedStore(storeList) {
      this.selectOther = storeList.findIndex(o => o !== "all") > -1;
      this.selectAll = storeList.findIndex(o => o === "all") > -1;
      if (this.selectAll) {
        this.ruleForm.shopIds = ["all"];
      }
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const {exportJsonToExcel} = require("@/utils/output/Export2Excel");
        const tHeader = ["商品货号", "商品条码"];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        exportJsonToExcel(tHeader, data, "导入模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });

        let goodsSnsAndSpecBarcode = [];
        result.forEach(v => {
          // if (v[0]) {
          //   goodsSns.push(v[0]);
          // }
          if (v[0] || v[1]) {
            goodsSnsAndSpecBarcode.push({
              goodsSn: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              specBarcode: v[1] ? (v[1] + "").replace(/\s*/g, "") : ""
            });
          }
        });

        // goodsSns = unique(goodsSns);
        that.$store
            .dispatch("queryWxshopSkuByGoodsSn", {goodsSnsAndSpecBarcode})
            .then(res => {
              const {code, result} = res;
              if (code === "0") {
                if (result.modelList.length > 0) {
                  result.modelList.forEach(v => {
                    v.bargainTotalStockSum = "";
                    v.eachPurchaseLimit = "1";
                    v.integralValue = "";
                  });
                  that.rule.push(...result.modelList);
                  that.rule = arrayUnique2(that.rule, "wxshopSkuId");
                  let list = [];
                  that.rule.forEach(v => {
                    if (v.goodsSn !== "") {
                      list.push(v);
                    }
                  });
                  that.rule = list;
                  that.$forceUpdate();
                }
                if (result.errGoodsSnsAndSpecBarcode.length > 0) {
                  that.errValidGoods = true;
                  that.errInputResult = result.errGoodsSnsAndSpecBarcode;
                }
              }
            });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    isString(value) {
      return typeof value === "string";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
            null,
            new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    activityDetail() {
      const {gameId} = this.$route.query;
      const params = {
        gameId
      };
      return this.$store.dispatch("queryActivitDetail", params);
    },
    cropSuccess() {
    },
    cropUploadFail() {
    },
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    filterGt0OrFixed(prop, i) {
      this.rule[i][prop] = this.rule[i][prop].replace(/^(0+)/, ""); //过滤0开头
      this.rule[i][prop] = this.rule[i][prop].replace(/[^\d]/g, ""); //仅保留数字
      this.rule[i][prop] = this.rule[i][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
      this.rule[i][prop] = this.rule[i][prop]
          .replace(".", "$#*")
          .replace(/\./g, "")
          .replace("$#*", "."); //去除其他"."
      this.rule[i][prop] = this.rule[i][prop].replace(
          /^(\d+)\.(\d\d).*$/,
          "$1.$2"
      ); //限制只能输入两个小数
      if (this.rule[i][prop].indexOf(".") < 0 && this.rule[i][prop] != "") {
        //首位是0的话去掉
        this.rule[i][prop] = parseFloat(this.rule[i][prop]);
      }
    },
    filterGt0OrFixed2(prop, i) {
      console.log("prop", this.rule);
      console.log("i", i);
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.rule[i][prop] = this.rule[i][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.rule[i][prop] = this.rule[i][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.rule[i][prop] = this.rule[i][prop]
          .replace(".", "$#*")
          .replace(/\./g, "")
          .replace("$#*", "."); //去除其他"."
      this.rule[i][prop] = this.rule[i][prop].replace(
          /^(\d+)\.(\d\d).*$/,
          "$1.$2"
      ); //限制只能输入两个小数
      if (this.rule[i][prop].indexOf(".") < 0 && this.rule[i][prop] != "") {
        //首位是0的话去掉
        this.rule[i][prop] = parseFloat(this.rule[i][prop]);
      }
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    toggleShow() {
      this.show = !this.show;
    },
    handleResize() {
      this.calcHeight();
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
            ? document.querySelector(".navbar").getBoundingClientRect().y
            : 0;
        const tagHeight = document.querySelector(".tags-view-container")
            ? document
                .querySelector(".tags-view-container")
                .getBoundingClientRect().y
            : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
            ? document.querySelector(".step-wrapper").getBoundingClientRect().y
            : 0;
        const footerHeight = document.querySelector(".el-footer")
            ? document.querySelector(".el-footer").getBoundingClientRect().height
            : 0;
        this.scrollHeight =
            window.innerHeight -
            headerHeight -
            tagHeight -
            stepsHeight -
            footerHeight -
            80;
      }, 0);
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else {
            this.currentStep = i - 1 <= 0 ? 1 : i - 1;
          }
        }
      });
    },
    addChild() {
      this.batchSetting();
    },
    deleteChild(index) {
      if (this.rule.length <= 1) {
        this.rule = [];
        this.addChild();
        return;
      }
      this.rule.splice(index, 1);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.gameStartTime =
              this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
                  ? this.ruleForm.activityDate[0]
                  : "";
          this.ruleForm.gameEndTime =
              this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
                  ? this.ruleForm.activityDate[1]
                  : "";


          let params = this.ruleForm;
          params.gameType = "help_coupon";
          params.gameBgp = this.listHeaderImgUrl;

          params = Object.assign(params, {
            couponRuleModelList: this.rule,
            isLook:'yes'
          });

          this.$store.dispatch("editActivity", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    handleRemove() {
      this.listHeaderImgUrl = "";
    },
    sample() {
      this.dialogVisible = true;
    },
    saveCoupons() {
      console.log("selectedCoupons=====", this.selectedCoupons);
      if (this.selectedCoupons.length > 0) {
        this.dialogVisible = false;
        if (this.rule.length === 1) {
          this.rule = [];
        }
        this.rule.push(...this.selectedCoupons);
        this.rule = arrayUnique2(this.rule, "couponSendId");
      } else {
        this.$message({
          message: "请选择优惠券",
          type: "warning"
        });
      }
    },
    setLink() {
      // if (this.currentLinkIndex !== -1) {
      //   this.currentProp[this.currentLinkPropName][
      //     this.currentLinkIndex
      //   ].goodsInfo = row;
      //   this.currentProp[this.currentLinkPropName][
      //     this.currentLinkIndex
      //   ].hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      // } else {
      //   this.currentProp.goodsInfo = row;
      //   this.currentProp.hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      // }
      this.dialogVisible = false;
      this.isRadio = false;
    },
    //查询优惠券
    queryCouponList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      }
      this.$store.dispatch("findCouponSendByEvent", params).then(res => {
        if (res.code === "0") {
          this.couponList = res.result;
        }
      });
    },
    batchSetting() {
      this.dialogVisible = true;
      this.queryCouponList();
    },
    minimum() {
      this.isCollapse = !this.isCollapse;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    ceshi(){
      console.log(this.ruleForm.activityDate);
    }
  }
};
</script>
<style lang="scss">
.add-goods-containers {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .step-wrapper {
    border-bottom: 1px solid #ddd;
  }

  .btn {
    margin-left: 10px;

    .hmicon {
      font-size: 12px;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss" scoped>
.fixed-but {
  position: fixed;
  top: 150px;
  right: 20px;
}

.pvw {
  .pvws {
    border: 1px solid #d9d9d9;
    width: 350px;
    margin-right: 100px;
    position: relative;
    position: fixed;
    right: 0;

    .commodityImg {
      width: 150px;
      height: 100px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .actcontent {
      width: 161px;
      height: 100px;
      margin-left: 20px;

      .activityTitle {
        font-size: 18px;
        font-weight: 600;
        margin-top: -1px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; //作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
        -webkit-line-clamp: 2; //显示的行
      }

      .activityPrice {
        font-size: 24px;
        color: #ff563a;
        font-weight: 600;
      }

      .originalCost {
        color: #919191;
      }
    }

    .hr {
      height: 10px;
      background-color: #f7f7f7;
    }

    .pvwimg {
      width: 100%;
      height: 100%;
      // position: relative;
    }

    .describe {
      width: 100%;
      color: #ffffff;
      font-size: 17px;
      position: absolute;
      left: 50%;
      margin-left: -50%;
      top: 248px;
    }
  }

  #audio_btn {
    position: absolute;
    left: 10px;
    top: 70px;
    z-index: 999999;
    width: 45px;
    height: 45px;
    background-image: url("https://imgcdn.hemiao100.com/hemiaoBase/ico_music.png");
    background-size: contain;
    background-repeat: no-repeat;
  }

  .rotate {
    -webkit-animation: rotating 1.2s linear infinite;
    -moz-animation: rotating 1.2s linear infinite;
    -o-animation: rotating 1.2s linear infinite;
    animation: rotating 1.2s linear infinite;
  }
}

.table {
  border: 1px solid #ddd;

  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }

  .table-row {
    padding: 5px 0;
    font-size: 14px;
  }

  .table-row:nth-child(even) {
    background: #f7f7f7;
  }

  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}

.priview {
  position: relative;
  width: 400px;
  height: 234px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;

  img {
    width: 100%;
    height: 100%;
  }

  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.act-container {
  max-width: 2000px;
  overflow-x: auto;

  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }

  .add-goods-container {
    width: 1128px;
    flex-shrink: 0;
  }

  .slot {
    .header-img-wrapper {
      box-sizing: border-box;

      .header-img {
        width: 100%;
        display: block;
      }
    }

    .empty {
      margin-top: 30px;
      text-align: center;
    }

    strong {
      font-size: 16px;
    }

    .preview-goods-list {
      padding: 15px;
      font-size: 12px;

      &:hover {
        .add-goods {
          display: block;
          position: absolute;
          cursor: pointer;
          display: none;
          top: 0;
          left: 0;
          z-index: 9030;
          zoom: 1;
          width: 34px;
          height: 34px;
          font-size: 12px;
          background-color: rgba(0, 0, 0, 0.8);
          border: 1px solid #fff;
          border-radius: 4px;
          text-align: center;
          line-height: 34px;
        }
      }

      .add-goods {
        position: absolute;
        top: 0;
        left: 0;
        display: none;
      }

      .coupon-item {
        position: relative;
        &:hover {
          .delete-item {
            display: block;
          }
        }

        .goods-head {
          border-radius: 20px;
          background-color: #FFC1C1;
          padding: 10px;
          margin-bottom: 10px;
          .head-ms {
            padding: 10px 5px;
            width: 75%;
            .ms {
              font-size: 16px;
              color: #F72B2B;
              margin-bottom: 20px;
              font-weight: bold;
            }
            .rule-bq {
              padding: 0px 4px;

              height: 25px;
              text-align: center;
              line-height: 25px;
              background: rgba(255, 255, 255, 0.46);
              border-radius: 18px;
              margin-right: 12px;
              font-size: 12px;
              color: #F72B2B;
            }
          }

          .head-btn {
            font-size: 16px;
            padding: 3px 5px 10px 5px;
            width: 25%;
            color: #F72B2B;
            font-weight: bold;
            .btn-wrapper {
              color: white;
              padding: 0px 6px;
              height: 38px;
              font-size: 14px;
              text-align: center;
              line-height: 38px;
              background: #F72B2B;
              border-radius: 24px;
            }
          }
        }

        .goods-item {
          background: #fff;
          margin-bottom: 10px;
          padding: 10px;
          border-radius: 5px;

          .rule-wrapper {
            width: 30%;
            padding: 0px 10px;
            font-size: 18px;
            color: #F72B2B;

            .rule-money {
              font-size: 48px;
            }
          }

          .goods-name {
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 10px;
          }

          .tag {
            font-size: 12px;
            padding: 0 5px;
            color: #fff;
            border-radius: 30px;
          }

          .origin-price {
            color: #999;
            margin-top: 8px;
            text-decoration: line-through;
          }
        }

      }
    }
  }

  .progress-wrapper {
    margin-bottom: 5px;

    .progress {
      position: relative;
      width: 134px;
      border-radius: 30px;
      overflow: hidden;
      height: 13px;
      line-height: 13px;

      .slide {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        height: 100%;
        border-radius: 30px;
      }
    }

    .percent {
      font-size: 12px;
      margin-left: 10px;
    }
  }
}

.font-ms {
  font-size: 14px;
  color: #666666;
}
</style>
